export const headCells = {
    docket: { id: "docket", label: "Docket", orderable: true, sticky: true },
    docket_restricted: {
        id: "docket",
        label: "Docket",
        orderable: true,
        sticky: true,
    },
    name: { id: "name", label: "Name", orderable: true },
    client_id: { id: "client_id", label: "Client", orderable: true },
    legal_entity_id: {
        id: "legal_entity_id",
        label: "Legal Entity",
        orderable: true,
    },
    status_id: { id: "status_id", label: "Status", orderable: true },
    start_date: { id: "start_date", label: "Start Date", orderable: true },
    end_date: { id: "end_date", label: "End Date", orderable: true },
    live_date: { id: "live_date", label: "Live Date", orderable: true },
    currency: { id: "currency", label: "Currency" },
    signed: { id: "signed", label: "Signed" },
    forecast_revenue: {
        id: "forecast_revenue",
        label: "Rev. Forecast",
        orderable: true,
        numeric: true,
    },
    confidence: { id: "confidence", label: "Confidence" },
    float_internal_scheduled: {
        id: "float_internal_scheduled",
        label: "Internal Scheduled",
        orderable: true,
        numeric: true,
    },
    float_internal_actual: {
        id: "float_internal_actual",
        label: "Internal Actual",
        orderable: true,
        numeric: true,
    },
    bid_internal_budget: {
        id: "bid_internal_budget",
        label: "Internal Budget",
        orderable: true,
        orderBy: "bid_internal_budget_base",
        numeric: true,
    },
    bid_quoted: {
        id: "bid_quoted",
        label: "Quoted Total",
        orderable: true,
        orderBy: "bid_quoted_base",
        numeric: true,
    },
    bid_hard_cost: {
        id: "bid_hard_cost",
        label: "Hard Cost Total",
        orderable: true,
        orderBy: "bid_hard_cost_base",
        numeric: true,
    },
    bid_gp: {
        id: "bid_gp",
        label: "GP Total",
        orderable: true,
        orderBy: "bid_gp_base",
        numeric: true,
    },
    accounting_rev: {
        id: "accounting_rev",
        label: "Billed",
        orderable: true,
        numeric: true,
    },
    accounting_cost: {
        id: "accounting_cost",
        label: "Spent",
        orderable: true,
        numeric: true,
    },
    percentage_complete: { id: "percentage_complete", label: "% Complete" },
    percentage_billed: { id: "percentage_billed", label: "% Billed" },
    earned_rev: { id: "earned_rev", label: "Earned Rev", numeric: true },
    ep_names: { id: "ep_names", label: "Executive Producers" },
    person_names: { id: "persons", label: "Team Members" },
    _actions: { id: "_actions", label: "" },
    first_forecast_date: {
        id: "first_forecast_date",
        label: "First Forecast Date",
    },
    last_forecast_date: {
        id: "last_forecast_date",
        label: "Last Forecast Date",
    },
    first_bill_date: { id: "first_bill_date", label: "First Bill Date" },
    last_bill_date: { id: "last_bill_date", label: "Last Bill Date" },
    project_type_id: { id: "project_type_id", label: "Project Type" },
    client_type: { id: "client_type", label: "Client Type" },
};
